import { gql } from '@apollo/client';

export const EngagementNotificationSettingFields = gql`
  fragment EngagementNotificationSettingFields on EngagementNotificationSetting {
    firstWindowMinutes
    secondWindowMinutes
    thirdWindowMinutes
    busyWindowMinutes
    quietResetHours
    countPeopleHours
    pushesPerHour
    pushesPerDay
  }
`;
